import React from "react";
import { Footer } from "shared/components/Footer";
import aboutUsBanner from "../../images/about-us-banner.jpg";
// import manish from "../../images/manish.jpeg";

// const people = [
//   {
//     name: "Manish Jung Thapa",
//     role: "Founder / CEO",
//     imageUrl: manish,
//   },
// ];

const stats = [
  { id: 1, name: "Active Sellers", value: "5,000+" },
  { id: 2, name: "Items Sold", value: "20,000+" },
  { id: 3, name: "New users annually", value: "46,000" },
];

export const AboutUs = () => {
  return (
    <div>
      <div className="relative isolate px-6 pt-14 lg:px-8">
        <div className="mx-auto max-w-2xl py-12">
          <div className="text-center flex flex-col space-y-12">
            <img src={aboutUsBanner} />
            <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">
              About Antidote
            </h1>
            <p className="mt-6 text-lg leading-8 text-gray-600">
              Antidote is an online thrift and consignment store where we enable
              sellers to sell their gently used items from the comfort of their
              home to thrifters all over Nepal. We provide an end-to-end service
              to our sellers, taking care of everything from the moment we
              collect the items from your home to the final sale of the items.
            </p>
            <p className="text-base font-semibold leading-7 text-indigo-600 hover:underline">
              <a href="https://sell.antidotenepal.com">
                Join over 5000+ sellers who use Antidote to de-clutter their
                space and closet.
                <br /> SELL NOW!!
              </a>
            </p>
          </div>
        </div>
      </div>
      <div className="bg-white py-24 sm:py-32">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <dl className="grid grid-cols-1 gap-x-8 gap-y-16 text-center lg:grid-cols-3">
            {stats.map((stat) => (
              <div
                key={stat.id}
                className="mx-auto flex max-w-xs flex-col gap-y-4"
              >
                <dt className="text-base leading-7 text-gray-600">
                  {stat.name}
                </dt>
                <dd className="order-first text-3xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
                  {stat.value}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
      {/* <div className="bg-white py-24 sm:py-32">
        <div className="mx-auto grid max-w-7xl gap-x-8 gap-y-20 px-6 lg:px-8 xl:grid-cols-3">
          <div className="max-w-2xl">
            <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
              Meet our team
            </h2>
            <p className="mt-6 text-lg leading-8 text-gray-600">
              Driven by a shared passion for innovation, collaboration, and
              creating the best marketplace for reselling. Get to know the faces
              behind the work:
            </p>
          </div>
          <ul
            role="list"
            className="grid gap-x-8 gap-y-12 sm:grid-cols-2 sm:gap-y-16 xl:col-span-2"
          >
            {people.map((person) => (
              <li key={person.name}>
                <div className="flex items-center gap-x-6">
                  <img
                    className="h-16 w-16 rounded-full"
                    src={person.imageUrl}
                    alt=""
                  />
                  <div>
                    <h3 className="text-base font-semibold leading-7 tracking-tight text-gray-900">
                      {person.name}
                    </h3>
                    <p className="text-sm font-semibold leading-6 text-indigo-600">
                      {person.role}
                    </p>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div> */}
      {/* <div
        className="mx-auto max-w-2xl lg:text-center p-12"
        style={{ background: "#f2f2f2", maxWidth: "1367px" }}
      >
        <h2 className="text-base font-semibold leading-7 text-indigo-600">
          Join Us Today
        </h2>
        <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
          Help us build a more sustainable future
        </p>
        <a className="block mt-4 hover:underline" href="#">
          Check out our open positions {`>`}
        </a>
      </div> */}
      <hr />
      <Footer />
    </div>
  );
};
